
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import * as React from 'react';
import { useRouter } from 'next/router';
import { isLocaleGerman } from '@/lib/data-transformer/gindumacUtils';
import LegalLayout from '@/components/layout/LegalLayout';
import { gtagContactEvent } from '@/lib/utilities/analytics/gtm';

export default function LogisticsServicesPage() {
  const { locale } = useRouter();
  return (
    <LegalLayout>
      {!isLocaleGerman(locale) ? (
        <>
          <h1 className='subtitle-legal'>Legal Notice</h1>
          <span className='date' />

          <p>
            Responsible within the meaning of Section 5 TMG [German Telemedia
            Act] is:
          </p>
          <p>
            GINDUMAC GmbH
            <br />
            Trippstadter Straße 110
            <br />
            67663 Kaiserslautern
            <br />
            Federal Republic of Germany
            <br />
            <br />
            Tel.: <a href='tel:+4963134373820'>+49 631 343738 20</a>
            <br />
            Email:{' '}
            <a onClick={gtagContactEvent} href='mailto:contact@gindumac.com'>
              contact@gindumac.com
            </a>
          </p>
          <p>
            Represented by the managing director: Benedikt Ruf, Daniel Kaiser
            <br />
            Register Court of the GmbH: Kaiserslautern County Court
            <br />
            Register number of the GmbH: HRB 32086
            <br />
            VAT ID No.: DE 307874459
          </p>
          <p>
            <strong>
              The responsible person according to Section 55 Par. 2 of the
              Interstate Broadcasting Treaty (RStV):
            </strong>
            <br />
            Benedikt RufTrippstadter Straße 110
            <br />
            67663 Kaiserslautern
          </p>
          <p>
            <strong>N.B.:</strong>The EU Commission offers the possibility for
            the settlement of disputes online on an online platform operated by
            it. This platform can be reached via the external link{' '}
            <a
              href='http://ec.europa.eu/consumers/odr/'
              target='_blank'
              rel='noreferrer'
              className='link'
            >
              http://ec.europa.eu/consumers/odr/
            </a>
            .
          </p>
          <p>
            <strong>Data protection</strong>
            <br />
            You can find our privacy notice here:
          </p>
          <p>
            <strong>RIGHTS</strong>:
            <br />
            <strong>©2017 GINDUMAC GmbH - All rights reserved</strong>
            <br />
            The web presence under the domain www.gindumac.com including the
            works contained therein- is protected under copyright law. Each
            exploitation, which is not explicitly permitted by the Copyright
            Act, requires the prior written consent of the website operator or
            the authors. A use of the works contained in the web presence is not
            permitted either without the explicit consent of GINDUMAC GmbH. This
            shall in particular apply to reproductions, making available to the
            public and editings as well as the storage of texts in electronic
            systems. Infringements will be prosecuted under civil and if
            applicable also criminal law.
          </p>
          <p>
            <strong>DISCLAIMER</strong>
            <br />
            {`Contents of third party websites, to which we refer directly or
            indirectly in our web presence in particular by "Links" or
            "Hyperlinks", lie outside of our area of responsibility. We do not
            adopt these. However, we can declare that at the time when the link
            was set no illegal contents on the linked websites were recognisable
            on the websites. We have no influence whatsoever on the current and
            future design, the contents and the authorship of the linked
            websites. Therefore, we explicitly distance ourselves from all
            contents of all linked websites, which should be changed after the
            link was set. This determination shall apply to all links and
            references set within the own web offer. Solely the provider of the
            site, to which reference was made, will be liable for illegal,
            faulty or incomplete contents and, in particular, for damages, which
            are suffered from the use of the information that can be called in
            the linked websites. If we gain knowledge of illegal, unlawful or
            faulty contents on websites, to which we have a link, we will remove
            the link.`}
          </p>
        </>
      ) : (
        <>
          <h1>Impressum</h1>
          <span className='date' />

          <p>Verantwortlich im Sinne des § 5 TMG ist:</p>
          <p>
            GINDUMAC GmbH
            <br />
            Trippstadter Straße 110
            <br />
            67663 Kaiserslautern
            <br />
            Bundesrepublik Deutschland
            <br />
            <br />
            Tel.: <a href='tel:+4963134373820'>+49 631 343738 20</a>
            <br />
            Email:{' '}
            <a onClick={gtagContactEvent} href='mailto:kontakt@gindumac.de'>
              kontakt@gindumac.de
            </a>
          </p>
          <p>
            Vertreten durch den geschäftsführenden Direktor: Benedikt Ruf
            <br />
            Registergericht der GmbH: Amtsgericht Kaiserslautern
            <br />
            Registernummer der GmbH: HRB 32086
            <br />
            USt-IdNr.: DE 307874459
          </p>
          <p>
            <strong>
              Verantwortlicher gemäß § 55 Abs. 2 des Rundfunkstaatsvertrages
              (RStV):
            </strong>
            <br />
            Benedikt Ruf
            <br />
            Trippstadter Straße 110
            <br />
            67663 Kaiserslautern
          </p>
          <p>
            <strong>HINWEIS:</strong>Die EU-Kommission bietet die Möglichkeit
            zur Online-Streitbeilegung auf einer von ihr betriebenen
            Online-Plattform. Diese Plattform ist über den externen Link{' '}
            <a
              href='http://ec.europa.eu/consumers/odr/'
              target='_blank'
              rel='noreferrer'
            >
              http://ec.europa.eu/consumers/odr/
            </a>{' '}
            zu erreichen.
          </p>
          <p>
            <strong>Datenschutz:</strong>
            <br />
            Unsere Datenschutzerklärung finden Sie hier:
          </p>
          <p>
            <strong>RECHTE:</strong>
            <br />
            <strong>©2017 GINDUMAC GmbH - Alle Rechte vorbehalten!</strong>
            <br />
            Der Webauftritt unter der Domain www.gindumac.com -einschließlich
            der in ihm enthaltenen Werke- ist urheberrechtlich geschützt. Jede
            Verwertung, die nicht ausdrücklich vom Urheberrechtsgesetz
            zugelassen ist, bedarf der vorherigen schriftlichen Zustimmung des
            Websitebetreibers bzw. der Autoren. Eine Verwendung der im
            Webauftritt enthaltenen Werke ist ohne ausdrückliche Zustimmung der
            GINDUMAC GmbH ebenfalls nicht gestattet. Dies gilt insbesondere für
            Vervielfältigungen, öffentliche Zugänglichmachungen und
            Bearbeitungen sowie die Einspeicherung von Texten in elektronischen
            Systemen. Zuwiderhandlungen werden zivil- und ggf. auch
            strafrechtlich verfolgt.
          </p>
          <p>
            <strong>DISCLAIMER</strong>
            <br />
            Inhalte fremder Webseiten, auf die wir in unserem Webauftritt
            insbesondere durch „Links“ oder „Hyperlinks“ direkt oder indirekt
            verweisen, liegen außerhalb unseres Verantwortungsbereichs. Wir
            machen uns diese nicht zu eigen. Wir können jedoch erklären, dass
            zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf den
            verlinkten Webseiten erkennbar waren. Auf die aktuelle und
            zukünftige Gestaltung, die Inhalte und die Urheberschaft der
            verlinkten Webseiten haben wir keinerlei Einfluss. Deshalb
            distanzieren wir uns ausdrücklich von allen Inhalten aller
            verlinkten Webseiten, die nach der Linksetzung geändert werden
            sollten. Diese Feststellung gilt für alle innerhalb des eigenen
            Webangebots gesetzten Links und Verweise. Für illegale, fehlerhafte
            oder unvollständige Inhalte und insbesondere für Schäden, die aus
            der Nutzung der in den verlinkten Webseiten aufrufbaren
            Informationen entstehen, haftet allein der Anbieter der Seite, auf
            welche verwiesen wurde. Erhalten wir von illegalen, rechtswidrigen
            oder fehlerhaften Inhalten auf Webseiten Kenntnis, auf die wir
            verlinken, werden wir die Verlinkung aufheben.
          </p>
        </>
      )}
    </LegalLayout>
  );
}


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/legal/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  